import { defineMessage } from 'react-intl';
export const viewerAskDenialMessage = defineMessage({
    defaultMessage: "Your Viewer seat doesn't include Ask.",
    id: 'a47e23ef77',
    description: 'Explains why an Enterprise Viewer cannot submit an Ask query',
});
//# sourceMappingURL=askAdmissionError.js.map